import { DehydratedState, QueryClient, dehydrate } from "@tanstack/react-query";

/**
 * Dehydrate a prefetched cache into something `getStaticProps` can return.
 *
 * Next refuses to serialize props containing `undefined`, and React Query's
 * dehydrated state carries whatever the API handed back. The round-trip drops
 * those keys instead of failing the build on one unexpected null-ish field.
 */
export const dehydrateForProps = (queryClient: QueryClient): DehydratedState =>
  JSON.parse(JSON.stringify(dehydrate(queryClient)));

/**
 * Absolute URL for canonical/og tags. Falls back to the production host so a
 * build without the env var still emits absolute URLs rather than relative
 * ones, which crawlers ignore in `og:url`.
 */
export const absoluteUrl = (path: string) => {
  const base = (process.env.NEXT_PUBLIC_WEB_URL || "https://www.fllite.com")
    .replace(/\/+$/, "")
    // The deployed value is currently http://, but the site 308s to https.
    // A canonical pointing at the pre-redirect URL is worse than no canonical,
    // so upgrade anything that is not a local dev host.
    .replace(/^http:\/\/(?!localhost|127\.0\.0\.1)/, "https://");

  return `${base}${path}`;
};
